var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import Button from '@doordash/component-button';
import ListCell from '@doordash/component-list-cell';
import { Icon, InlineChildren, Text, Spacing, Colors, } from '@doordash/design-language';
import styled from 'styled-components';
import { getOrderHistoryMonths } from '../../utils/order_history_helper';
import { BFF_DOWNLOAD_ORDER_HISTORY_API_PATH } from '../../constants/values';
import { WorkBenefit } from '../../types/GloblalTypes';
import BillingHistoryStrings from './BillingHistoryStrings';
import { OrderHistoryPageTestId } from '../testId';
import Popover from '@doordash/component-popover';
import track from '../../utils/track';
import { OrderHistoryEvents } from '../../constants/events';
var FILE_FORMAT;
(function (FILE_FORMAT) {
    FILE_FORMAT["PDF"] = "pdf";
    FILE_FORMAT["CSV"] = "csv";
})(FILE_FORMAT || (FILE_FORMAT = {}));
var ListContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  border-radius: ", "px;\n  width: 100%;\n  box-shadow: ", "px ", "px ", "px\n    rgba(0, 0, 0, 0.3);\n"], ["\n  background: ", ";\n  border-radius: ", "px;\n  width: 100%;\n  box-shadow: ", "px ", "px ", "px\n    rgba(0, 0, 0, 0.3);\n"])), Colors.SystemWhite, Spacing.XxxSmall, Spacing.None, Spacing.None, Spacing.XxSmall);
var FileFormatList = function (_a) {
    var teamAccountId = _a.teamAccountId, monthData = _a.monthData, benefitType = _a.benefitType;
    var downloadUrl = BFF_DOWNLOAD_ORDER_HISTORY_API_PATH + "?team_account_id=" + teamAccountId + "&start_date=" + monthData.startDate + "&end_date=" + monthData.endDate + "&workBenefit=" + benefitType;
    // pdf format receipt is only available to accounts which have EM benefit
    return (React.createElement(ListContainer, null,
        benefitType === WorkBenefit.WORK_BENEFIT_EXPENSED_MEALS && (React.createElement(ListCell, { size: ListCell.Sizes.Small, title: React.createElement(Text, { styles: Text.Styles.Medium14 }, BillingHistoryStrings.downloadPdfTitle()), href: downloadUrl + "&fileFormat=" + FILE_FORMAT.PDF, tag: "a", onClick: function () {
                track(OrderHistoryEvents.DOWNLOAD_BILLING_HISTORY, {
                    team_account_id: teamAccountId,
                    benefit_type: benefitType,
                    file_format: FILE_FORMAT.PDF,
                });
            } })),
        React.createElement(ListCell, { size: ListCell.Sizes.Small, title: React.createElement(Text, { styles: Text.Styles.Medium14 }, BillingHistoryStrings.downloadCsvTitle()), href: downloadUrl + "&fileFormat=" + FILE_FORMAT.CSV, tag: "a", onClick: function () {
                track(OrderHistoryEvents.DOWNLOAD_BILLING_HISTORY, {
                    team_account_id: teamAccountId,
                    benefit_type: benefitType,
                    file_format: FILE_FORMAT.CSV,
                });
            } })));
};
var BillingMonthRowData = function (_a) {
    var teamAccountId = _a.teamAccountId, isEmActivated = _a.isEmActivated, shouldShowDpBillingDownload = _a.shouldShowDpBillingDownload;
    var _b = __read(React.useState(false), 2), showingEMDownloadLayer = _b[0], setShowingEMDownloadLayer = _b[1];
    var _c = __read(React.useState(false), 2), showingDPDownloadLayer = _c[0], setShowingDPDownloadLayer = _c[1];
    var _d = __read(React.useState(null), 2), selectedStartDate = _d[0], setSelectedStartDate = _d[1];
    var handleOnClickEMDownload = function (monthData) {
        setSelectedStartDate(showingEMDownloadLayer ? '' : monthData.startDate);
        setShowingDPDownloadLayer(false);
        setShowingEMDownloadLayer(!showingEMDownloadLayer);
    };
    var handleOnClickDPDownload = function (monthData) {
        setSelectedStartDate(showingDPDownloadLayer ? '' : monthData.startDate);
        setShowingEMDownloadLayer(false);
        setShowingDPDownloadLayer(!showingDPDownloadLayer);
    };
    return (React.createElement(React.Fragment, null, getOrderHistoryMonths().map(function (monthData) { return (React.createElement(ListCell, { key: monthData.startDate, size: ListCell.Sizes.Small, title: monthData.monthString, titleOverrides: { lineHeight: Text.Sizes.S32, size: Text.Sizes.S18 }, renderAfterContent: function () { return (React.createElement(InlineChildren, { size: InlineChildren.Sizes.XLarge },
            isEmActivated && (React.createElement(Popover, { position: Popover.Positions.BottomCenter, showContainerPointer: false, isVisible: showingEMDownloadLayer &&
                    monthData.startDate === selectedStartDate, interactionType: Popover.InteractionTypes.Controlled, onVisibilityChange: function () { return handleOnClickEMDownload(monthData); }, content: React.createElement(FileFormatList, { teamAccountId: teamAccountId, monthData: monthData, benefitType: WorkBenefit.WORK_BENEFIT_EXPENSED_MEALS }) }, function (_a) {
                var describedBy = _a.describedBy;
                return (React.createElement(Button, { "data-testid": OrderHistoryPageTestId.DownloadFileDropdownEM, accessibilityDescribedBy: describedBy, type: Button.Types.Tertiary, isInline: true, onClick: function () { return handleOnClickEMDownload(monthData); }, trailingIcon: monthData.startDate === selectedStartDate &&
                        showingEMDownloadLayer
                        ? Icon.Types.ChevronUp
                        : Icon.Types.ChevronDown }, BillingHistoryStrings.downloadButtonTitle()));
            })),
            shouldShowDpBillingDownload && (React.createElement(Popover, { position: Popover.Positions.BottomCenter, showContainerPointer: false, isVisible: showingDPDownloadLayer &&
                    monthData.startDate === selectedStartDate, interactionType: Popover.InteractionTypes.Controlled, onVisibilityChange: function () { return handleOnClickDPDownload(monthData); }, content: React.createElement(FileFormatList, { teamAccountId: teamAccountId, monthData: monthData, benefitType: WorkBenefit.WORK_BENEFIT_DASHPASS }) }, function (_a) {
                var describedBy = _a.describedBy;
                return (React.createElement(Button, { "data-testid": OrderHistoryPageTestId.DownloadFileDropdownDP, accessibilityDescribedBy: describedBy, type: Button.Types.Tertiary, isInline: true, onClick: function () { return handleOnClickDPDownload(monthData); }, trailingIcon: monthData.startDate === selectedStartDate &&
                        showingDPDownloadLayer
                        ? Icon.Types.ChevronUp
                        : Icon.Types.ChevronDown }, BillingHistoryStrings.downloadButtonTitle()));
            })))); } })); })));
};
export default BillingMonthRowData;
var templateObject_1;
